<template>
  <main>
    <header>
      <div class="hubday-tabs">
        <div class="hubday-section">
          <div class="hubday-head">
            <i class="material-icons-outlined">emoji_people</i>Liste des professeurs
          </div>
          <div class="hubday-body">
            <table v-if="teachers!=null" class="teacher-list">
              <tr v-for="teacher in teachers" v-bind:key="teacher.idNum" class="teacher">
                <td class="teacher-name">
                  <div>
                  <i class="material-icons-outlined">account_circle</i>
                  <div>{{teacher.displayName}}</div></div>
                </td>
                <td class="teacher-mail">{{teacher.email}}</td>
                <td
                  v-html="'<div style=\'border-left: 4px solid #afdab9;\'>' + teacher.modules.join('</div><div style=\'border-left: 4px solid #afdab9;\'>') + '</div>'"
                  class="teacher-module"
                ></td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </header>
  </main>
</template>

<style scoped>
.teacher {
  margin: 15px 0 15px 0;
  color: #333;
  border: none;
}
.teacher i {
  margin-right: 10px;
  color: #333;
}

.teacher td {
  vertical-align: top;
}

.teacher-name>div {
  display: flex;
}

.teacher-module {
  padding-left: 7px;
}
</style>

<style>
.teacher-module div {
  margin-bottom: 5px;
  padding-left: 6px;
}
</style>

<script>
import { mapState } from "vuex";
import * as firebase from "firebase/app";
import "firebase/database";
const rtdb = firebase.database();

export default {
  data() {
    return {
      teachers: null
    };
  },
  methods: {},
  mounted() {
    var teachersRef = rtdb.ref("teachers");
    var self = this;
    teachersRef.on("value", function(snapshot) {
      self.teachers = snapshot.val();
    });
  }
};
</script>